import { useBreakpointValue } from '@chakra-ui/react';

import { useRealPathname } from './router';

export const useMaxContentWidth = (): string | undefined => {
  const pathName = useRealPathname();
  const doApply = useBreakpointValue({ base: true, sm: false });

  return undefined;

  // should use constants if there will be more paths
  // return useMemo(
  //   () =>
  //     (pathName === '/iframe-vvs' || pathName === '/iframe-vvs-dark') && doApply
  //       ? MAXW_IFRAME
  //       : undefined,
  //   [pathName, doApply],
  // );
};
